import React from "react";
import PropTypes from "prop-types";

// styled components
import ErrorStyled from "./ErrorWrapper.styled";

const Error = ({ error }) => {
    return (
        <ErrorStyled>
            <p className="helper error">{error}</p>
            <span className="form__error form__group__error m52__form__error" aria-hidden="true"></span>
        </ErrorStyled>
    );
};

// props validation
Error.propTypes = {
    error: PropTypes.string.isRequired
};

export default Error;
